import {cookie} from '@prismicio/client';
import {useCookie} from '#imports';

function useIsPreview() {
    return !!useCookie(cookie.preview).value;
}

function createPreviewHelper() {
    return {
        isPreview: useIsPreview,
    };
}

export default createPreviewHelper;
